export interface MarppleShopAdminMenuActionOption {
  service?: string;
  pass_no_service?: boolean;
  actions?: string;
  target?: string;
}

export interface MarppleShopAdminMenu {
  path: string;
  name: string;
  icon_html?: string;
  action_option?: MarppleShopAdminMenuActionOption;
  filter?: (data: any) => boolean;
  sub_menus?: MarppleShopAdminMenu[];
}

export const ADMIN_LNB_MENU_ID = {
  SOLUTION: 'solution/list',
} as const;
